<template>
    <div>
        <!-- Begin Page Content -->
        <div class="symptom">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body">
                            <h1 class="d-flex justify-content-start align-items-center back-page"><i class="icon icon-chevron-down"></i>Symptom Checker</h1>
                            <div class="row no-gutters">
                                <div class="col-lg-7 col-12">
                                    <div class="card border-0 h-100">
                                        <div class="card-body p-0 text-left">
                                            <p class="pt-4 pb-4 pl-3">Experiencing symptoms but the doctor away Asymptom checker will help you by providing accurate result.</p>
                                            <form class="form-search parts-form position-relative pl-3 mb-5">
                                                <button class="btn button search"><i class="icon icon-search"></i></button>
                                                <input type="text" name="text" placeholder="Neck" />
                                            </form>
                                            <div class="row no-gutters w-100 searches justify-content-center">
                                                <div class="col-md-10">
                                                    <div class="row justify-content-center mb-4">
                                                        <div class="col-sm-3 col-6 list">
                                                            <a href="#"> <i class="icon icon-heart"></i> <span class="d-block">Heart</span></a>
                                                        </div>
                                                        <div class="col-sm-3 col-6 list">
                                                            <a href="#"> <i class="icon icon-brainstorm"></i> <span class="d-block">Brain</span> </a>
                                                        </div>
                                                        <div class="col-sm-3 col-6 list">
                                                            <a href="#"> <i class="icon icon-depression"></i> <span class="d-block">Stress</span> </a>
                                                        </div>
                                                        <div class="col-sm-3 col-6 list">
                                                            <a href="#"> <i class="icon icon-immunity"></i> <span class="d-block">Immunity</span> </a>
                                                        </div>
                                                    </div>
                                                    <div class="row justify-content-center mb-4">
                                                        <div class="col-sm-3 col-6 list">
                                                            <a href="#"> <i class="icon icon-joint"></i> <span class="d-block">Joints</span> </a>
                                                        </div>
                                                        <div class="col-sm-3 col-6 list">
                                                            <a href="#"> <i class="icon icon-stomach"></i> <span class="d-block">Digestion</span> </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-5 col-12 mb-md-5">
                                    <div class="card border-0 h-100">
                                        <div class="card-body p-0 d-flex justify-content-center">
                                            <div>
                                                <figure><img src="../../../../static/website/images/Front.svg" alt="" /></figure>
                                                <a href="#" class="d-flex justify-content-center align-items-center Rotate"><i class="icon icon-Rotate"></i> Rotate</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="questions-section">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="bg-white border-radius-5 p-3">
                        <h2 class="text-center my-4">Related Questions</h2>
                        <form class="form-search position-relative d-flex justify-content-center align-items-center mb-5">
                            <button class="btn button search"><i class="icon icon-search"></i></button>
                            <input type="text" name="text" placeholder="Search Question" />
                        </form>
                        <div class="row no-gutters">
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "symptom-checker",
        data() {
            return {};
        },
        created(){
           this.pageName('Consultation')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/checkup/symptom-checker.vue